$(document).ready(function(){

    function deepEqual(obj1, obj2) {

        if (obj1 === obj2) {
            return true;
        }
        else {
            if (Object.keys(obj1).length != Object.keys(obj2).length) { // Проверка на одинаковое количество свойств
                return false;
            }
            for (var propName in obj1) {

                if (!obj2.hasOwnProperty(propName)) { // Есть ли свойства в обоих объектах
                    return false;
                }
                if (obj1[propName].valueOf() !== obj2[propName].valueOf()) { // Одинаковы ли значения свойст 
/*                     if(!deepEqual(obj1[propName], obj2[propName])) { // проверка объекта в объекте
                        return false;
                    } */
                    // console.log(obj1[propName]);
                }
            }
        }
        return true;
    }

    var objA = {
        prop1: 'value-11',
        prop2: 'value-12',
        prop3: 'value-13',
        prop5: 1000
        // prop6: new Date(2016, 2, 10)
    };

    var objB = {
        prop1: 'value-21',
        prop2: 'value-22',
        prop3: 'value-23',
        prop5: 2000
        // prop6: new Date(2015, 2, 10)
    };

    deepEqual(objA, objB);

});
